import { SelectedState } from "../../lib/selected-state.js";
import { titleCase, formatCurrency } from "../../lib/utils.js";
import { html } from "lit";
import { property, customElement } from "lit/decorators.js";
import "../../common/legal-disclaimer.js";
import "../../common/descriptor-list.js";
import "../../common/promotional-description.js";
import "../../common/offer-header.js";
import "../../common/landing-page-action.js";
import { when } from "lit/directives/when.js";
import { MultiOfferQuoteElement } from "../../lib/multi-offer-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let GapMedical = class extends MultiOfferQuoteElement {
  constructor() {
    super("gap-medical");
    this.participantCountry = "US";
  }
  /**
   * @ignore
   */
  _renderMultiDisplay() {
    var _a, _b, _c;
    return html`
      <offer-checkbox-button @change=${this.toggleOfferSelection} ?checked=${this.selectedState === SelectedState.ACCEPTED}>
        <div class="multi-offer-item">
          <div>Include <strong>${titleCase(this.coverageType)}</strong> Package for ${this.participantFirstName} ${this.participantLastName} ${when(this.coverageContextDescription, () => html`(${this.coverageContextDescription})`)}</div>
          <div>${((_a = this.quote) == null ? void 0 : _a.total) || ((_b = this.quote) == null ? void 0 : _b.premium_amount) ? formatCurrency(((_c = this.quote) == null ? void 0 : _c.total) || this.quote.premium_amount, this.quote.currency) : ""}</div>
        </div>
      </offer-checkbox-button>
    `;
  }
  /**
   * @ignore
   */
  get policyAttributes() {
    return {
      covered_person: {
        first_name: this.participantFirstName,
        last_name: this.participantLastName,
        state: this.participantState,
        street: this.participantStreetAddress,
        birth_date: this.participantBirthDate,
        country: this.participantCountry
      },
      coverage_type: this.coverageType,
      coverage_start_date: this.coverageStartDate,
      coverage_end_date: this.coverageStartDate
    };
  }
};
GapMedical.styles = [
  MultiOfferQuoteElement.styles
];
__decorateClass([
  property({ attribute: "coverage-type" })
], GapMedical.prototype, "coverageType", 2);
__decorateClass([
  property({ attribute: "coverage-start-date" })
], GapMedical.prototype, "coverageStartDate", 2);
__decorateClass([
  property({ attribute: "coverage-end-date" })
], GapMedical.prototype, "coverageEndDate", 2);
__decorateClass([
  property({ attribute: "participant-first-name" })
], GapMedical.prototype, "participantFirstName", 2);
__decorateClass([
  property({ attribute: "participant-last-name" })
], GapMedical.prototype, "participantLastName", 2);
__decorateClass([
  property({ attribute: "participant-street-address" })
], GapMedical.prototype, "participantStreetAddress", 2);
__decorateClass([
  property({ attribute: "participant-state" })
], GapMedical.prototype, "participantState", 2);
__decorateClass([
  property({ attribute: "participant-country" })
], GapMedical.prototype, "participantCountry", 2);
__decorateClass([
  property({ attribute: "participant-birth-date" })
], GapMedical.prototype, "participantBirthDate", 2);
GapMedical = __decorateClass([
  customElement("gap-medical")
], GapMedical);
export {
  GapMedical
};
